import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

/**
Copyright 2016 Split Software

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

    http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.
**/
import logFactory from '../../utils/logger';
var log = logFactory('splitio-engine:value');
import sanitizeValue from './sanitize';
function parseValue(key, attributeName, attributes) {
  var value = undefined;
  if (attributeName) {
    if (attributes) {
      var _context;
      value = attributes[attributeName];
      log.debug(_concatInstanceProperty(_context = "Extracted attribute [".concat(attributeName, "], [")).call(_context, value, "] will be used for matching."));
    } else {
      log.warn("Defined attribute [".concat(attributeName, "], no attributes received."));
    }
  } else {
    value = key;
  }
  return value;
}
/**
 * Defines value to be matched (key / attribute).
 */

function value(key, matcherDto, attributes) {
  var attributeName = matcherDto.attribute;
  var valueToMatch = parseValue(key, attributeName, attributes);
  var sanitizedValue = sanitizeValue(matcherDto.type, valueToMatch, matcherDto.dataType, attributes);
  if (sanitizedValue !== undefined) {
    return sanitizedValue;
  } else {
    var _context2;
    log.warn(_concatInstanceProperty(_context2 = "Value ".concat(valueToMatch, " ")).call(_context2, attributeName ? "for attribute ".concat(attributeName, " ") : +'', "doesn't match with expected type."));
    return;
  }
}
export default value;